<script setup>
    
    const commercialStore = useCommercialStore()

    const { width, height } = defineProps({
        width: {
            type: String,
            default: '100%'
        }, 
        height: {
            type: String,
            default: '100%'
        }
    })

    const popoverListShow = ref( false );
    const clusterElements = ref([])
    const clusterCount = ref(0)
    const getCommercialItems = async cluster => {
        setTimeout( async () => {
            if( cluster.length > 0 ){
                let slice = cluster.map( cl => cl.geometry.coordinates[0])
                let sliceRepeat = Array.from(new Set( slice ))
                if( sliceRepeat.length == 1 ){
                    const ids = cluster.map( e => e.properties._id )
                    popoverListShow.value = true
                    const { items, total } = await commercialStore.getQuery({
                        ids
                    }, false, true)
                    popoverShow.value = false
                    clusterElements.value = items
                    clusterCount.value = total
                }
            }
        }, 150);
    }
    
    const popoverShow = ref( false );
    const selectElement = ref(null)
    const getCommercialItem = async id => {
        if( parseInt(id) > 0 ){
            const { items, total } = await commercialStore.getQuery({
                id
            }, false, true)
            popoverShow.value = false
            popoverListShow.value = false
            selectElement.value = null
            if( items.length > 0 ){
                popoverShow.value = true
                selectElement.value = items[0]
            }
        }
    }

    const markers = computed(() => {
        return commercialStore.coordinates.map( e => {
            return {
                coordinates: [ parseFloat( e.lon ), parseFloat( e.lat ) ],
                properties: {
                    _id: e.id
                },
            }
        })
    })

    const onUpdate = () => {
        console.log('click map')
        if(popoverShow.value) popoverShow.value = false
        if(popoverListShow.value) popoverListShow.value = false
    }

    const trueBounds = ref([]);
    import {
        YandexMap,
        YandexMapMarker,
        YandexMapClusterer,
        YandexMapControls,
        YandexMapControl,
        YandexMapDefaultFeaturesLayer,
        YandexMapDefaultSchemeLayer,
        YandexMapListener,
    } from "vue-yandex-maps";

</script>
<template>
    <yandex-map
        cursor-grab
        :settings="{
            location: {
                center: [ 30.314997, 59.938784 ], 
                zoom: 9, 
            },
            //camera: { azimuth: 0, tilt: (40 * Math.PI) / 180, duration: 250 },
            // showScaleInCopyrights: true,
        }"
        :width="width" 
        :height="height"
    >
        <yandex-map-default-scheme-layer/>
        <yandex-map-default-features-layer/>
        <yandex-map-controls :settings="{ position: 'top right', orientation: 'vertical' }">
            <yandex-map-control>
                <div v-if="popoverShow" class="button-element bg-gray-150 h-auto w-64 p-0">
                    <LayoutsCard v-if="selectElement.is_mama == 'off'" :item="selectElement" />
                    <LayoutsCardBc v-if="selectElement.is_mama == 'on'" :item="selectElement" />
                </div>
                <div v-if="popoverListShow" class="bg-gray-150 h-auto w-64 p-0 rounded-xl">
                    <CatalogCardList v-model="clusterElements" />
                </div>
            </yandex-map-control>
        </yandex-map-controls>
        <yandex-map-clusterer
            :grid-size="64"
            zoom-on-cluster-click
            @trueBounds="trueBounds = $event"
        >
            <yandex-map-marker
                v-for="marker in markers"
                :key="marker._id"
                :settings="marker"
            >
                <div @click="getCommercialItem( marker.properties._id )" class="bg-brand-primary cursor-pointer p-0 rounded-full w-5 h-5 flex items-center justify-center text-sm font-medium text-white border border-blue-500">
                    
                </div>
            </yandex-map-marker>
            <template #cluster="{ clusterer, coordinates, length }">
                <div @click="getCommercialItems( clusterer.features )" class="bg-brand-green cursor-pointer p-0 rounded-full w-10 h-10 flex items-center justify-center text-sm font-medium text-black border border-green-500" >
                    {{ length }}
                </div>
            </template>
        </yandex-map-clusterer>
        <yandex-map-listener
        :settings="{
            onFastClick: onUpdate,
        }"
    />
    </yandex-map>
</template>